
import { Box, Typography, getContrastRatio } from "@mui/material"
import { useState } from "react"
import { customTheme as theme } from "../../theme/customTheme";
import ErrorHeader from "./ErrorHeader";
import CustomButton from "../../components/CustomButton";
import Footer from "../unauthv2/components/Footer";
import { generateLighterContrastColor } from "../../utils/commonServices";
import ErrorPageImage from "./assets/ErrorPageImage";

const ErrorPage = (props) => {

  const { componentStack, error } = props;
  const [displayError, updateDisplay] = useState(false)

  const primary = localStorage.getItem('primary')
  const secondary = localStorage.getItem('secondary')

  console.log('Lucihub Error Page')


  return (
    <>
      <Box sx={{ width: '100%', position: "fixed", height: "100vh", minWidth: "100vw", display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundImage: primary === null && secondary === null ? 'linear-gradient(110deg, #F7F7F730,  #E6E6E650, #F7F7F730 , #E6E6E650, #E6E6E670,#00CEFF20 , #00CEFF50 80%,  #00D74460 , #00D74460 )' : `linear-gradient(110deg, #F7F7F730,  #E6E6E650, #F7F7F730 , #E6E6E650, #E6E6E670,${secondary}20 , ${secondary}50 80%,  ${primary}60 , ${primary}60 )` }}>
        <ErrorHeader />
        <Box width='100%' className='flex row a-center' sx={{ justifyContent: 'center', flex: 1, py: 4 }} pl={{ sm: 10 }} pb={4}>
          <Box className='flex col j-start a-center' gap={3} sx={{ width: '44%', maxWidth: '600px', minWidth: '280px' }}>
            <Typography sx={{ color: 'black', fontWeight: 800, textAlign: 'left', fontSize: { xs: '13px', md: '15px', lg: '17px', xl: '22px' }, lineHeight: 1.4, fontFamily: 'Rubik' }}>Oh Shoot. It looks like your session expired or the page doesn't exist. </Typography>
            <Typography variant="h2" sx={{ fontWeight: 800, color: 'black', textAlign: 'left', fontSize: { xs: '28px', md: '34px', lg: '40px', xl: '52px' }, lineHeight: 1.2, fontFamily: 'Rubik' }}>Please go home to continue. </Typography>
            <Box width='100%' sx={{ mt: 1, display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, justifyContent: 'flex-start', alignItems: { xs: 'center', sm: 'flex-start' } }} >

              <CustomButton
                variant="contained"
                btnText="Go Home"
                style={{ borderRadius: '8px', border: "none", textTransform: 'none' }}
                onClick={() => {window.localStorage.clear(); window.location.reload() }}
                sx={{ fontSize: { xs: '13px', sm: '13px', md: '15px', lg: '17px', xl: '22px' }, fontWeight: 600, height: { xs: '32px', sm: '32px', md: '36px', lg: '40px', xl: '50px' }, width: { xs: '110px', sm: '110px', md: '130px', lg: '150px', xl: '185px' }, fontFamily: 'Rubik', backgroundColor: '#08231B', color: theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' : getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main) }} />

            </Box>
          </Box>
          {/* <Box flexDirection='column'>

          <Box sx={{ marginY: { xs: '15px', md: '20px', lg: '25px', xl: '38px' } }}>
            <Typography
              variant="h4"
              color="primary"
              style={{
                fontWeight: 600,
                color: '#08231B'
              }}
              sx={{ fontSize: { xs: '30px', sm: '40px', md: '40px', lg: '50px', xl: '80px' }, fontFamily: 'Rubik' }}
            >Oh Shoot.</Typography>
          </Box>
          
          <Box item xs={11} sm={8} md={7} gap={0.8} sx={{ display: 'flex', flexDirection: 'column', }}>
            <Typography sx={{ color: '#707070', fontSize: { xs: '12px', md: '14px', lg: '16px', xl: '20px' }, fontFamily: 'Helvetica' }}>The page you were looking for does not exist.</Typography>
          </Box>

          <Box width='100%' sx={{ mt: 3, display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, justifyContent: { xs: 'flex-start', sm: 'flex-start' }, alignItems: { xs: 'center', sm: 'flex-start' } }} >

            <CustomButton 
            variant="contained"
              btnText="Go Home"
              color='button'
              style={{ borderRadius: '5px', border: "none", textTransform: 'none', }}
              onClick={() => navigate('/dashboard', { replace: true })}
              sx={{ fontSize: { xs: '10px', sm: '10px', md: '11px', lg: '12px', xl: '16px' }, fontWeight: 600, height: { xs: '18px', sm: '20px', md: '22px', lg: '24px', xl: "32px" }, width: { xs: '100px', lg: '120px', xl: '160px' }, fontFamily: 'Rubik', backgroundColor: '#08231B',color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main) }} />

          </Box>

        </Box> */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }} pl={{ xs: 2, sm: 4, md: 8, lg: 10, xl: 12 }}>
            <Box sx={{ height: { xs: 160, sm: 180, md: 200, lg: 220, xl: 270 }, marginBottom: { xs: '12px', sm: '14px', md: '16px', lg: '18px', xl: '26px' } }}>
            <ErrorPageImage sx={{height: '100%', width: '50%', maxWidth: '350px'}} />
              {/* <img src={notFoundImage} alt="notFoundImage" height='100%' style={{objectFit:'cover', borderRadius:'10px'}} /> */}
            </Box>
          </Box>

        </Box>
        {/* commented out block */}
     
        <Footer />
      </Box>
    </>
  );
}

export default ErrorPage;
